import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{attrs:{"dark":"","label":"","close":"","nuxt":"","to":_vm.to,"color":_vm.banColor,"close-icon":_vm.closeIcon},on:{"click:close":function($event){return _vm.revertBan(_vm.ban)}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }